module.exports = __webpack_public_path__ + "img/LaBase-PanCakes-600px.56427687.jpg";